import Game from './Game'
import List from './List'
import ListDemo from './ListDemo'
import Wrapper from './Wrapper'
import Homework from './Homework'
import Abacus from './Abacus'
import Settings from './Settings'

export default {
	Game,
	List,
	ListDemo,
	Wrapper,
	Homework,
	Abacus,
	Settings,
}
